<template>
    <LandscapeScreen v-if="screen == 'game' && !phoneScreen.landscape && gamer.length > 1"/>
    <fs v-model="fullscreen" class="h-full w-full select-none " v-else>
        <div class="relative font-addition flex flex-col h-full w-full bg-repeat bg-center bg-white" :style="`background-image: url('${$t('files_url')}img/games/addition/bg_pattern.png')`">

            <!-- sarkıt -->
            <div class="flex flex-col absolute top-0 left-0 w-full  z-0" :class="screen == 'game' && phoneScreen.landscape  && screen == 'game' ? 'h-24 lg:h-2/6' : 'h-2/6'">
                <div :class="screen == 'game' || screen == 'result' ? 'h-5/6' : 'h-5/6'" class=" w-full games-addition-bg-gradate flex items-center justify-center">
                    <img class="h-full" :src="`${$t('files_url')}${$t('addition_logo')}`" alt="" v-if="['home', 'result'].includes(screen)">
                </div>
            </div>

            <!-- voice and  full screen-->
            <div class="absolute right-2 bottom-2  z-40">
                <div class="flex justify-center items-center space-x-3">
                    <button @click="screen = 'home'" v-if="screen == 'game'">
                        <ReplyIcon class="w-6 lg:w-8"/>
                    </button>

                    <button @click="volume = !volume">
                        <VolumeUpIcon class="w-6 lg:w-8" v-if="volume"/>
                        <VolumeOffIcon class="w-6 lg:w-8" v-else/>
                    </button>

                    <button @click="fullscreen = !fullscreen">
                        <ArrowsExpandIcon class="w-6 lg:w-8"/>
                    </button>
                </div>
            </div>

            <!-- header -->
            <header class="z-10">
                <div class="lg:p-2 p-2 flex justify-around items-start">
                    <!-- sol -->
                    <div class="w-full"></div>
                    <!-- orta -->

                    <div class="w-full">
                        <!-- timer -->
                        <vue-countdown :time="time*1000" @progress="timerProgressFNC" @end="finishedTime" v-if="screen == 'game'"/>
                    </div>

                    <!-- sağ üst menü -->
                    <div class="w-full"></div>
                </div>

                <div class="rounded-lg px-2" v-if="screen == 'game' && gamer">
                    <FirstProgress :current_time="currentTime" :gamer="gamer" :store_point="getStorePoint"
                                   v-if="gamer.length == 1"/>
                    <SecondProgress :current_time="currentTime" :gamer="gamer" v-if="gamer.length == 2"/>
                </div>
            </header>

            <!-- content -->
            <main class="h-full z-10" :class="screen == 'options' && 'overflow-auto'">
                <HomeScreen @screen="setScreenEvent" @start="setStart" v-if="screen == 'home'"/>
                <ResultScreen @score="setStorePoint" :heightScore="heightScore" @screen="setScreenEvent" v-if="screen == 'result'" :gamer="gamer" :time="time"/>

                <div class="flex h-full" v-if="screen == 'game'">
                    <div class="w-full" v-for="(g,key) in gamer" :key="key">
                        <GameScreen
                            v-if="screen == 'game'"
                            :gamer="g"
                            :time="currentTime"
                            :volume="volume"
                            @screen="setScreenEvent"
                            @add_point="addPoint"
                            :first_multiplier="first_multiplier"
                            :second_multiplier="second_multiplier"
                        />
                    </div>
                </div>

                <OptionsScreen
                    v-if="screen == 'options'"
                    @screen="setScreenEvent"
                    :first_multiplier="first_multiplier"
                    :second_multiplier="second_multiplier"
                    :time="time"
                    :volume="volume"
                    @multiplier="setMultiplier"
                />
            </main>
        </div>
    </fs>
</template>

<script setup>
import {ArrowsExpandIcon, ReplyIcon, VolumeOffIcon, VolumeUpIcon} from "@heroicons/vue/outline";
import {useScreen} from 'vue-screen'
import {computed, ref, watch, defineProps} from 'vue'
import useSound from './sounds'
import FirstProgress from './components/other/GameProgressFirst.vue'
import SecondProgress from './components/other/GameProgressSecond.vue'
import OptionsScreen from "./components/screen/Options.vue"
import ResultScreen from "./components/screen/Results.vue"
import HomeScreen from "./components/screen/Home.vue"
import GameScreen from "./components/screen/Game.vue"
import LandscapeScreen from "./components/screen/Landscape.vue"
import VueCountdown from '@chenfengyuan/vue-countdown';
import language from './language/index.js'
import i18next from 'i18next';
import { earnGameCompletionBadge } from '../../helpers/badge';

const fullscreen = ref(false)
const phoneScreen = useScreen()
const heightScore = ref(0)
const gameCompleted = ref(false)

const props = defineProps(['filesUrl'])
const {soundStart, soundSetVolume} = useSound({files_url:props.filesUrl})

const screen = ref("home")
const first_multiplier = ref([1, 2])
const second_multiplier = ref([1])
const time          = ref(60)
const gamer         = ref(null)
const volume        = ref(true)
const currentTime   = ref(0)
i18next.addResourceBundle('tr', 'translation', {...language.tr, files_url: props.filesUrl || '/'}, true, true);
i18next.addResourceBundle('en', 'translation', {...language.en, files_url: props.filesUrl || '/'}, true, true);

const addPoint = (g) => {
    gamer.value[g.gamer] = g
}

watch(screen, (screen, _) => {
    if (screen == "game") {
        soundStart(3)
    } else {
        soundStart(2)
    }
})

soundSetVolume(volume.value)
watch(volume, (volume, _) => {
    soundSetVolume(volume)
})


const getStorePoint = computed(() => {
    return heightScore.value;
})

const setStorePoint = (newScore) => {
    heightScore.value = newScore;
}


const setScreenEvent = (selectScreen) => {
    screen.value = selectScreen
}


const getTime = computed(() => {
    return time.value
})


const finishedTime = () => {
    screen.value = "result"
    
    if (!gameCompleted.value) {
        if (gamer.value && gamer.value.length === 1) {
            if (gamer.value[0].point > 0) {
                gameCompleted.value = true;
                earnGameCompletionBadge();
            }
        } 
        else if (gamer.value && gamer.value.length === 2) {
            if (gamer.value[0].point !== gamer.value[1].point) {
                gameCompleted.value = true;
                earnGameCompletionBadge();
            }
        }
    }
}

const setStart = (newGamer) => {
    screen.value = "game"
    const addGamer = {
        point: 0,
        bestAnswer: 0
    }

    const gamerArr = []
    for (let index = 0; index < newGamer; index++) {
        gamerArr.push({gamer: index, ...addGamer})
    }

    gamer.value = gamerArr
}

const timerProgressFNC = (t) => {
    const sn = t.totalMilliseconds / 1000
    currentTime.value = Math.ceil(sn)
    if (sn < 10) {
        soundStart(4)
    }
}

const setMultiplier = (obj) => {
    soundStart(2)
    if (obj.selected == "first") {
        if (first_multiplier.value.includes(obj.number)) {
            if (first_multiplier.value.length != 1) {
                first_multiplier.value = first_multiplier.value.filter(i => i != obj.number)
            }
        } else {
            first_multiplier.value.push(obj.number)
        }
    } else if (obj.selected == "second") {
        if (second_multiplier.value.includes(obj.number)) {
            if (second_multiplier.value.length != 1) {
                second_multiplier.value = second_multiplier.value.filter(i => i != obj.number)
            }
        } else {
            second_multiplier.value.push(obj.number)
        }
    } else if (obj.selected == "time") {
        time.value = obj.number
    }
}
</script>

<style>
.colors{
    background-color: #eb7213;
    background-color: #ffde14;
    background-color: #e44848;
    background-color: #e50069;
}

.games-addition-bg{
    background-color: #e44848;
}

.games-addition-bg-gradate{
    background-image: radial-gradient(#e50069, #e50069, #e44848);
}

.games-addition-border{
    border: solid 4px #e44848;
}

.games-addition-bg-light{
    background-color: #e50069;
}
.games-addition-secondary{
    background-color: #ffde14;
}

.games-addition-secondary-gridant{
    background-image: linear-gradient(to right, #ffde14  40%, #eb7213 99% 100%);
}

.games-addition-text-color-question{
    color: #E50069;
}

.games-addition-gridant{
    background-image: linear-gradient(to bottom, #ffde14  40%, #eb7213 99% 100%);
}

.games-addition-text-color-secondery{
    color: #ffde14;
}

.games-addition-border-color-secondery{
    border-color: #ffde14;
}

.games-addition-text-color-primary{
    color: #e44848;
}


</style>
